exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".new-profile-btn[data-v-0f66c90f] {\n  padding-bottom: 2em;\n}\n", ""]);

// exports
